export enum WorkflowTableIdentity {
  AdminDashboard = 'AdminDashboard',
  ContentSuggestionsDashboard = 'ContentSuggestionsDashboard',
  AuthorContents = 'AuthorContents',
  ContentRequestsTable = 'ContentRequestsTable',
  ContentRequestsAssignmentTable = 'ContentRequestsAssignmentTable',
  ContentRequests = 'ContentRequests',
  ContentsToPublish = 'ContentsToPublish',
  ContentsToReview = 'ContentsToReview',
  ContentsToFinalize = 'ContentsToFinalize',
  ReFinalize = 'ReFinalize',
  TechwriterDashboard = 'TechwriterDashboard',
  TechwriterDashboardNew = 'TechwriterDashboardNew',
  AuthorContentSuggestions = 'AuthorContentSuggestions',
  ContentSuggestionDashboard = 'ContentSuggestionDashboard',
  TechwriterAssignment = 'TechwriterAssignmentTable',
  ContentToReview = 'ContentToReview',
  AuthoredContent = 'AuthoredContent',
  SharedContent = 'SharedContentTable',
  ContentUpdates = 'ContentUpdates',
  ManagePosts = 'ManagePosts',
  DraftBarRaiserDashboard = 'DraftBarRaiserDashboard',
  PublishedBarRaiserDashboard = 'PublishedBarRaiserDashboard',
}

export enum TabIdentity {
  HomePage = 'HomePage',
  TechWriterDashBoard = 'TechWriterDashBoard',
  AuthorContent = 'AuthorContent',
  PendingToFinalize = 'PendingToFinalize',
  MyQueue = 'myqueue',
  AllContent = 'allContent',
}

export enum ExpandableSectionIdentity {
  TechWriterDashboardGraph = 'TechWriterDashboardGraph',
  SideNavAdmin = 'SideNavAdmin',
  SideNavTechWriter = 'SideNavTechWriter',
  SideNavWhatsNew = 'SideNavWhatsNew',
  SideNavReviewerActions = 'SideNavReviewerActions',
  SideNavPublisherActions = 'SideNavPublisherActions',
  SideNavBarRaiser = 'SideNavBarRaiser',
}
